import { useEffect, useState } from 'react';

/**
 * 为了解决 react-query 关键字重复请求
 * see https://github.com/tannerlinsley/react-query/issues/293
 * see https://usehooks.com/useDebounce/
 */
const useKeywordDebounce = (value: string, delay: number) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
};

export default useKeywordDebounce;
